console.log('fuck you doo doo boy');

const mobileButton = document.querySelector('.header__mobile-toggle');
const navMenu = document.querySelector('.header__nav-wrapper');

mobileButton.addEventListener('click', () => {
    navMenu.classList.toggle('active');
});

function is_mobile() {
    if (window.innerWidth <= 768) {
        console.log('we is mobile');
        return true;
    } else {
        console.log('we is not mobile');
        return false;
    }
}

if (!is_mobile()) {
    navMenu.classList.add('active');
}